import { render, staticRenderFns } from "./newsFeedAdmin.vue?vue&type=template&id=451b225d&"
import script from "./newsFeedAdmin.vue?vue&type=script&lang=js&"
export * from "./newsFeedAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports